import React, { useEffect, useState } from 'react';
import './ScraperForm.css';

function ScraperForm({ onScrape, onDownload, loading }) {
  const [formData, setFormData] = useState({
    query: '',
    location: '',
    maxResults: 20,
    businessVertical: ''
  });
  const [businessVerticals, setBusinessVerticals] = useState([]);
  const [verticalStatus, setVerticalStatus] = useState('loading');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  useEffect(() => {
    let isMounted = true;

    async function fetchBusinessVerticals() {
      try {
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5052';
        const response = await fetch(`${apiUrl}/api/config/business-verticals`);

        if (!response.ok) {
          throw new Error('Failed to load business vertical configuration');
        }

        const data = await response.json();
        if (!isMounted) return;

        setBusinessVerticals(data.values || []);
        const fallback =
          formData.businessVertical ||
          data.values?.[0]?.id ||
          'Unknown';

        setFormData(prev => ({
          ...prev,
          businessVertical: fallback
        }));
        setVerticalStatus('ready');
      } catch (error) {
        console.error('Failed to load business vertical configuration:', error);
        if (!isMounted) return;
        setBusinessVerticals([{ id: 'Unknown', label: 'Unknown' }]);
        setFormData(prev => ({
          ...prev,
          businessVertical: prev.businessVertical || 'Unknown'
        }));
        setVerticalStatus('error');
      }
    }

    fetchBusinessVerticals();
    return () => {
      isMounted = false;
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.query && formData.location) {
      onScrape(formData);
    }
  };

  const handleDownloadClick = (e) => {
    e.preventDefault();
    if (formData.query && formData.location) {
      onDownload(formData);
    }
  };

  return (
    <form className="scraper-form" onSubmit={handleSubmit}>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="query">Business Type / Query</label>
          <input
            type="text"
            id="query"
            name="query"
            value={formData.query}
            onChange={handleChange}
            placeholder="e.g., restaurants, hotels, dentists"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="businessVertical">Business Vertical</label>
          <select
            id="businessVertical"
            name="businessVertical"
            value={formData.businessVertical}
            onChange={handleChange}
            disabled={verticalStatus === 'loading'}
          >
            {businessVerticals.map(option => (
              <option key={option.id} value={option.id}>
                {option.label}
              </option>
            ))}
          </select>
          {verticalStatus === 'error' && (
            <p className="helper-text">
              Unable to load dropdown options. Defaulting to &quot;Unknown&quot;.
            </p>
          )}
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="location">Location</label>
          <input
            type="text"
            id="location"
            name="location"
            value={formData.location}
            onChange={handleChange}
            placeholder="e.g., New York, NY or 10001"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="maxResults">Max Results</label>
          <input
            type="number"
            id="maxResults"
            name="maxResults"
            value={formData.maxResults}
            onChange={handleChange}
            min="1"
            max="100"
          />
        </div>
      </div>

      <div className="form-actions">
        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading || !formData.query || !formData.location}
        >
          {loading ? 'Scraping...' : 'Scrape & View Results'}
        </button>

        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleDownloadClick}
          disabled={loading || !formData.query || !formData.location}
        >
          {loading ? 'Processing...' : 'Scrape & Download Excel'}
        </button>
      </div>
    </form>
  );
}

export default ScraperForm;


